import React from 'react';

import type { FC } from 'react';

export const CheckCircleOutline: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
      <path d="M6.99935 1.16797C3.77935 1.16797 1.16602 3.7813 1.16602 7.0013C1.16602 10.2213 3.77935 12.8346 6.99935 12.8346C10.2193 12.8346 12.8327 10.2213 12.8327 7.0013C12.8327 3.7813 10.2193 1.16797 6.99935 1.16797ZM6.99935 11.668C4.42685 11.668 2.33268 9.5738 2.33268 7.0013C2.33268 4.4288 4.42685 2.33464 6.99935 2.33464C9.57185 2.33464 11.666 4.4288 11.666 7.0013C11.666 9.5738 9.57185 11.668 6.99935 11.668ZM9.67685 4.42297L5.83268 8.26714L4.32185 6.76214L3.49935 7.58464L5.83268 9.91797L10.4993 5.2513L9.67685 4.42297Z" />
    </svg>
  );
};
